import React from "react";
import { AnnotisedMessage } from "../Chat/ChatBody";
const PublicProfileAbout = props => {
  const { about } = props;

  return (
    <React.Fragment>
      <div className="event-page-public-profile-content-text">
        <AnnotisedMessage message={about} />
      </div>
    </React.Fragment>
  );
};

export default PublicProfileAbout;
